import {
  Control,
  FieldValues,
  Path,
  RegisterOptions,
  useController,
} from 'react-hook-form'
import TextAreaInputBase from './textarea-input-base'
import { cn } from 'components/UI/cn'

export function TextareaInput<T extends FieldValues>({
  name,
  label,
  control,
  placeholder,
  maxLength,
  secondaryLabel,
  optional = false,
  className,
  rules,
}: {
  control: Control<T>
  name: Path<T>
  label?: string
  placeholder?: string
  type?: string
  maxLength?: number
  optional?: boolean
  secondaryLabel?: string
  className?: string
  rules?: RegisterOptions<T>
}) {
  const {
    field: { ref, onChange, value },
    fieldState: { error },
  } = useController({ name: name, control, rules })

  return (
    <div className={cn('flex flex-col mt-3 w-full', className)}>
      {label && (
        <label
          htmlFor={name}
          className="text-base font-medium text-gray-800 select-none"
        >
          {label}
          {optional && (
            <span className={'text-sm italic font-normal'}> - optional</span>
          )}
          {secondaryLabel && (
            <span className={'text-sm italic font-normal'}>
              {secondaryLabel}
            </span>
          )}
        </label>
      )}
      <TextAreaInputBase
        id={name}
        onChange={onChange}
        value={value}
        ref={ref}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      <p className="text-fg">{error?.message ?? ''}</p>
    </div>
  )
}
